/*
 * Service posInstance
 */
angular
  .module('posApp')
  .factory(
    'posInstance',
    (handleData: any, loadFailure: any, translate: ng.ITranslateService) => {
      const $translate = translate;

      const posInstance = {
        nr: undefined,
        loaded: false,
        init: () => {
          return handleData.getNewPosInstanceId().then(
            (posInstanceId: string) => {
              posInstance.nr = posInstanceId;
              posInstance.loaded = true;
            },
            () => {
              loadFailure($translate.instant('Error108'));
            },
          );
        },
      };

      return posInstance;
    },
  );
